// extracted by mini-css-extract-plugin
export default {"myTabs":"tabs_myTabs__agcRV","badge":"tabs_badge__7etWR","badge-yellow":"tabs_badge-yellow__yxEDH","badge-green":"tabs_badge-green__2Q0+9","badge-red":"tabs_badge-red__3MciI"};